import { TablePaginationConfig } from "antd";
import { fetchWalletDetailByDriverIdApi } from "api/wallet";
import { useNotificationContext } from "contexts/NotificationContext";
import { jwtDecode } from "jwt-decode";
import { ERole } from "models/account";
import {
  defaultWalletDetail,
  IDriverWalletDetailResponse,
} from "models/driverWallet";
import { ChangeEvent, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

export default function useDriverWalletDetail() {
  const id: string = useParams().id!;
  const { showError } = useNotificationContext();
  const [data, setData] =
    useState<IDriverWalletDetailResponse>(defaultWalletDetail);

  useEffect(() => {
    fetchData();
  }, [data.page]); // eslint-disable-line

  const role: ERole = useMemo(() => {
    const payload: any = jwtDecode(localStorage.getItem("token")!);
    return payload.role;
  }, []);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await fetchWalletDetailByDriverIdApi(
      id,
      data.page,
      data.per_page
    );
    if (response) {
      response.data.histories = response.data.histories.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return { data, role, handlePageChange, handleSearch };
}
